import { render } from "./LoadingSpinner.vue?vue&type=template&id=4cbbfd64&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=4cbbfd64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbbfd64"]])

export default __exports__